/**
 * @generated SignedSource<<2f9f783fbd83a4293b2fa6c223ccf8c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StartWhen = "ITEM_ADDED" | "ITEM_DELETED" | "ITEM_UPDATED" | "NO_START" | "%future added value";
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
export type ProcessDefinitionInput = {
  definitionKey: string;
  definitionName: string;
  definitionPriority: number;
  definitionVersion?: string | null | undefined;
  definitionXml: string;
  id?: string | null | undefined;
  list: string;
  listName?: string | null | undefined;
  siteUrl: string;
  startWhen: StartWhen;
  status: Status;
};
export type processDefinitionQueryMutation$variables = {
  input: ProcessDefinitionInput;
};
export type processDefinitionQueryMutation$data = {
  readonly saveProcessDefinition: {
    readonly id: string;
  } | null | undefined;
};
export type processDefinitionQueryMutation = {
  response: processDefinitionQueryMutation$data;
  variables: processDefinitionQueryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProcessDefinition",
    "kind": "LinkedField",
    "name": "saveProcessDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionQueryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionQueryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0f7d214094ede91bf92d64ff6fe44680",
    "id": null,
    "metadata": {},
    "name": "processDefinitionQueryMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionQueryMutation(\n  $input: ProcessDefinitionInput!\n) {\n  saveProcessDefinition(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b883c955d2e3c89532290abfd755d9f";

export default node;
